import * as React from 'react';
import { ReactNode } from 'react';
import { ExecutionHandler } from '../execution-handler';
import { IJobExecutionRunner, IJobTriggerRunner } from '../index';
import { AlertErrorMessage } from '../../../components/global/modal/alerts-host/types/alert/alert-error-message';
import JobAlertsTemplates from '../../../components/_jobs-monitor-host/job-types';
import { JobMapper } from './job-mapper';
import { JobsAlertsService } from './jobs-alerts.service';


export class JobResultHandler extends ExecutionHandler {
    static composeTriggerMessage(job: IJobTriggerRunner, additionalProps?: { description: string}): string | ReactNode {
        if (job.hasTriggerConflict()) return `
            Your "${job.description}" cannot be processed at this time
            because there is another operation in progress within this event.
            \n Please try again later.
        `;

        if (job.hasFailedTrigger()) {
            return React.createElement(AlertErrorMessage, {
                message: job.getResult()?.['failureReason'] ?? `${job.description} has failed`,
                title: job.description
            });
        }

        if (job.isTriggered()) return additionalProps?.description || `${job.description} has started`;
    }

    static composeExecutionMessage(job: IJobExecutionRunner): string | ReactNode {
        return React.createElement(JobAlertsTemplates[job.type][job.getStatus()], JobMapper.toDto(job));
    }


    public handleJobTriggerResult(result: IJobTriggerRunner, handler?: () => void, additionalProps?: { description: string}): void {
        const msg = JobResultHandler.composeTriggerMessage(result, additionalProps);
        JobsAlertsService.showAlert(msg, {onClose: handler});
    }

    public handleJobExecutionResult(result: IJobExecutionRunner, handler?: () => void): void {
        const msg = JobResultHandler.composeExecutionMessage(result);
        JobsAlertsService.showAlert(msg, {title: result.description, onClose: handler});
    }
}
